import FormField from "common/components/ui/FormField";
import WorkspaceAccountSelector from "common/components/WorkspaceAccountSelector";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface LinkedInAccountFormFieldProps {
  accountId: string;
  setAccountId: (accountId: string) => void;
}

export default function LinkedInAccountFormField({
  accountId,
  setAccountId,
}: LinkedInAccountFormFieldProps) {
  const isDesktop = useTwBreakpoint("lg");

  return (
    <FormField
      label="Targeting account"
      htmlFor="linkedin-account-selector"
      className="w-44 shrink-0"
    >
      <WorkspaceAccountSelector
        selection={accountId}
        setSelection={setAccountId}
        size={isDesktop ? "md" : "lg"}
        align="start"
      />
    </FormField>
  );
}
